'use client'

import { useTranslation } from '@/lib/i18n/useTranslation.client'
import { isSSR } from '@/lib/next/services/nextjs.rendering'
import { usePathname } from 'next/navigation'
import { useLayoutEffect } from 'react'

/**
 * If the computed document title contains only the brand name (or is empty
 * after removing it), replace it with the baseline metadata title.
 * This prevents blank or brand-only page titles.
 */
export function PageTitleFallback() {
  const { t } = useTranslation(['generic'])
  const pathname = usePathname()
  const fallbackTitle = t('generic:metadata.title').trim()

  useLayoutEffect(() => {
    if (isSSR) return

    // If the template results in a brand-only title, replace it with the baseline metadata title.
    const currentTitle = window.document.title.trim()
    const isBrandOnly = currentTitle === '' || currentTitle.startsWith('| ')

    if (isBrandOnly && fallbackTitle) {
      window.document.title = fallbackTitle
    }
  }, [fallbackTitle, pathname])

  return null
}
